export default "data:image/svg+xml,%3Cpath%20d%3D%22M19%2013H5v-2h14v2z%22%20%2F%3E"